import { createIcon } from "@chakra-ui/react";

export const Empty = createIcon({
  displayName: "Fun",
  viewBox: "0 0 48 48",
  path: [
    <path
      d="M47.531 0H25.5l-3 3 11.25 10.5 1.5-1.5L47.531 0z"
      fill="#CBD5E0"
    />,
    <path d="m34.5 12-12-12H.75l12 12H34.5z" fill="#E2E8F0" />,
    <path
      d="M45 27c0 11.598-9.402 21-21 21S3 38.598 3 27 12.402 6 24 6s21 9.402 21 21z"
      fill="#E2E8F0"
    />,
  ],
  defaultProps: {
    "aria-label": "A medal shape"
  }
});

export default Empty;
